import React from 'react';
import {Box, Card, CardContent, Chip, Drawer, IconButton, Stack, Typography,} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import getCheckboxDisplayLabel from '../../../../utility/getCheckboxDisplayLabel';

/** Normalize to array: backend may return linkedFormFilters, linkedForms, or legacy linkedForm (single). */
function getLinkedFormCriteria(group) {
    const list = group.linkedFormFilters ?? group.linkedForms;
    if (Array.isArray(list) && list.length > 0) return list;
    if (group.linkedForm) return [group.linkedForm];
    return [];
}

/* eslint-disable react/prop-types */
const GroupDrawer = ({open, onClose, formName, groups = []}) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
        >
            <Box
                sx={{
                    width: {
                        xs: '100vw',
                        sm: 450
                    },
                    height: '100%',
                    overflowY: 'auto',
                    padding: 3,
                    boxSizing: 'border-box'
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center">
                    <Typography variant="h6" fontWeight="bold">
                        Groups Created from This Form
                    </Typography>
                    <IconButton onClick={onClose}><CloseIcon/></IconButton>
                </Box>
                <Typography variant="body2" color="text.secondary" marginBottom={2}>
                    Groups that have been created based on responses from <strong>{formName}</strong>
                </Typography>
                <Stack spacing={2}>
                    {groups.map((group, i) => {
                        const criteria = getLinkedFormCriteria(group);
                        return (
                            <Card key={i} variant="outlined">
                                <CardContent>
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                        >
                                            {
                                                group.isMyGroup
                                                    ? <GroupIcon fontSize="small"/>
                                                    : <SchoolIcon fontSize="small"/>
                                            }
                                            {group.name}
                                        </Typography>
                                        <Chip label={group.isMyGroup ? 'My Group' : 'School Group'} size="small"/>
                                    </Box>
                                    {criteria.length > 0
                                        ? criteria.map((item, j) => (
                                            <Box key={j} sx={{mt: 1}}>
                                                <Typography variant="body2">
                                                    <strong>Question:</strong> {item.question ?? '—'}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Answer:</strong> {item.questionType === 'checkboxQuestion'
                                                        ? getCheckboxDisplayLabel(item.answer)
                                                        : (item.answer ?? '—')}
                                                </Typography>
                                            </Box>
                                        ))
                                        : (
                                            <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
                                                All responses (no question filter)
                                            </Typography>
                                        )}
                                </CardContent>
                            </Card>
                        );
                    })}
                </Stack>
            </Box>
        </Drawer>
    );
};

export default GroupDrawer;
